export enum FunctionsApi {
  RemoveTagsFromResources = 'removeTagsFromResources',
  UpdatePost = 'updatePost',
  DeletePost = 'deletePost',
}
